import React from 'react';
import AdminDashboard from './AdminDashboard.component.js';

export default function Admin() {
  return <AdminDashboard />;
}

Admin.propTypes = {};
